import React, { useEffect } from 'react';
import { create } from 'jss';
import StylesProvider from '@mui/styles/StylesProvider';
import jssPreset from '@mui/styles/jssPreset';
import { useSelector } from 'react-redux';
import { ConfirmProvider } from 'react-use-confirm';
import { StyledEngineProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { initYup } from 'helpers/yup';
import { configureAxios } from 'helpers/axios';
import { useCustomTheme } from 'hooks/useCustomTheme';
// import { ConfirmProvider } from 'hooks/useConfirm';
import { GlobalStyles } from 'styles/global';
import CriticalRequests from 'containers/CriticalRequests';
import ThemeProvider from 'components/theme/ThemeProvider';
import { selectPhoneMask } from 'store/slices/appConfigSlice';
import ConfirmDialog from 'components/ConfirmDialog';
import ErrorBoundary from 'components/ErrorBoundary';

import 'styles/vendor/reset.css';

import Routes from './Routes/Routes';
import AppMeta from './AppMeta';
import AppErrorFallback from './AppErrorFallback';

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point'),
});

configureAxios();

function App() {
  const { theme } = useCustomTheme();

  const phoneMask = useSelector(selectPhoneMask);

  useEffect(() => {
    if (!phoneMask) return;

    initYup({ phoneMask });
  }, [phoneMask]);

  return (
    <>
      <AppMeta />
      <ErrorBoundary fallback={<AppErrorFallback theme={theme} />}>
        <CriticalRequests>
          <StylesProvider jss={jss}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <GlobalStyles />
                  <ConfirmProvider ConfirmComponent={ConfirmDialog}>
                    <Routes />
                  </ConfirmProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </LocalizationProvider>
          </StylesProvider>
        </CriticalRequests>
      </ErrorBoundary>
    </>
  );
}

export default App;
